export default "__VITE_ASSET__Cs7$Qi33__"